import { render, staticRenderFns } from "./AssignedBook.vue?vue&type=template&id=28e48c70&scoped=true&"
import script from "./AssignedBook.vue?vue&type=script&lang=js&"
export * from "./AssignedBook.vue?vue&type=script&lang=js&"
import style0 from "./AssignedBook.vue?vue&type=style&index=0&id=28e48c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e48c70",
  null
  
)

export default component.exports